import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { db } from '../../helpers/firebaseHelper';

const initState = {
  value: '',
  rows: 1,
  minRows: 1,
  maxRows: 8,
};

export default class Compose extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initState, ...this.props };
  }

  _handleChange = event => {
    const textareaLineHeight = 24;
    const { minRows, maxRows } = this.state;

    const previousRows = event.target.rows;
    event.target.rows = minRows; // reset number of rows in textarea

    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      event.target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }

    this.setState({
      value: event.target.value,
      rows: currentRows < maxRows ? currentRows : maxRows,
    });
  };

  _handleKeyDown = e => {
    if (this.props.sendWithButton) {
      return;
    }
    if (e.keyCode === 13 && !e.shiftKey) {
      let dateSend = new Date();
      e.preventDefault();
      const textMsg = e.target.value.trim();

      // test if message is empty and if not continue
      if (textMsg === '') return;

      let sendingMsg = {
        _id: uuid(),
        createdAt: dateSend,
        received: true,
        sent: true,
        text: e.target.value.trim(),
        user: {
          _id: this.props.userId,
          name: this.props.userName,
          avatar: this.props.avatar,
        },
      };

      if (this.props.avatar !== '') {
        sendingMsg.user.avatar = this.props.avatar;
      }

      this.setState(initState);

      db.collection('messages')
        .doc(this.props.msgActive)
        .collection('data')
        .add(sendingMsg);
      db.collection('messages')
        .doc(this.props.msgActive)
        .update({
          hasLast: true,
          showing: { [this.props.advertiser]: true, [this.props.sender]: true },
          last: {
            ...sendingMsg,
            createdAt: dateSend,
            read: false,
            unreadFor:
              this.props.advertiser === this.props.userId
                ? this.props.sender
                : this.props.advertiser,
          },
        });
      if (this.props.callBackSend) {
        this.props.callBackSend(e.target.value.trim());
        return;
      }
    }
  };

  render() {
    return (
      <div className="compose">
        <textarea
          rows={this.state.rows}
          value={this.state.value}
          placeholder="Écrivez votre message..."
          onKeyDown={this._handleKeyDown}
          className={'textarea compose-input'}
          onChange={this._handleChange}
        />
        {this.props.rightItems}
      </div>
    );
  }
}
